import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { getAPICall, postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import MESSAGES from "../constants/messages";
import { handleSnackBar } from "./global";
import generalService from "../services/general.service";

export const fetchAllManufacturerAction = createAsyncThunk(
  "general/manufacturer",
  async (_, { dispatch }) => {
    try {
      const resp: any = await generalService.listAllManufacturer({ body: {} }); //getAPICall(nextAPIRoutes.MANUFACTURER)
      return resp?.data?.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const fetchAllManufacturerModalsAction = createAsyncThunk(
  "general/manufacturerModals",
  async ({ id }: { id: number }, { dispatch }) => {
    try {
      const resp: any = await generalService.listAllManufacturerModals({
        body: { id },
      });
      // postAPICall(nextAPIRoutes.MANUFACTURER_MODELS, {
      //   id: id,
      // })
      return resp?.data?.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const fetchAllAttachmentsAction = createAsyncThunk(
  "general/attachments",
  async (_, { dispatch }) => {
    try {
      const resp: any = await generalService.listAllAttachments({ body: {} }); //postAPICall(nextAPIRoutes.ATTACHMENTS, {})
      return resp?.data?.data ?? [];
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const generalSlice: any = createSlice({
  name: "generalReducer",
  initialState: {
    manufacturer: { loading: false, data: [] },
    models: { loading: false, data: [] },
    attachments: { loading: false, data: [] },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllManufacturerAction.pending, (state, { payload }) => {
        state.manufacturer = { loading: true, data: [] };
        state.models = { loading: false, data: [] };
      })
      .addCase(fetchAllManufacturerAction.fulfilled, (state, { payload }) => {
        state.manufacturer = { loading: false, data: payload };
        state.models = { loading: false, data: [] };
      })
      .addCase(
        fetchAllManufacturerModalsAction.pending,
        (state, { payload }) => {
          state.models = { loading: true, data: [] };
        }
      )
      .addCase(
        fetchAllManufacturerModalsAction.fulfilled,
        (state, { payload }) => {
          state.models = { loading: false, data: payload };
        }
      )
      .addCase(fetchAllAttachmentsAction.pending, (state, { payload }) => {
        state.attachments = { loading: true, data: [] };
      })
      .addCase(fetchAllAttachmentsAction.fulfilled, (state, { payload }) => {
        state.attachments = { loading: false, data: payload };
      });
  },
});

export default generalSlice.reducer;
